export default __webpack_public_path__ + "assets/images/c78398ef0cc664c7d0ac9cd5de867abe.webp";